import React from "react";
import { Error } from "../Forms/FormFieldInputNew";
import TreeSelect from "./TreeSelect";
import styles from "./Select.module.scss";
import classNames from "classnames";
import { Formidable } from "./../../";
import { MenuType } from "../Widgets/TreeList";

const FormFieldTreeSelect = React.memo(({
    treeData,
    childKey = 'childrens',
    labelKey = 'label',
    dropdownUpIcon,
    dropdownDownIcon,
    menuType = MenuType.SINGLE,
    defaultSelectedValues = [],
    isOptionDisabled,
    onChange,
    customSelectorStyles,
    inlineSelect = false,
    isSearchable = false,
    isRequireAcceptOnChange = false,
    searchPlaceholder = 'Search...',
    selectPlaceholder = "Select...",
    customFilter,
    noOptionsMessage,
    menuPortalTarget,
    isSelectDisabled = false,
    uniqueIdentifier,
    iconRenderer,
    label,
    name,
    errorMessage,
    showError,
    errorType,
    expandLevel,
    className,
    bottomBorder,
    customStyles,
    value
}) => {

    return <div className={classNames(styles.base, styles['margin-bottom'], className)}>
                <label className={classNames({ [styles["disabled"]]: isSelectDisabled })}>
                    {label && <span className={classNames(styles["label"])}>{label}</span>}
                    <TreeSelect
                        menuPortalTarget={menuPortalTarget}
                        treeData={treeData}
                        selectPlaceholder={selectPlaceholder}
                        menuType={menuType}
                        labelKey={labelKey}
                        onChange={onChange}
                        isRequireAcceptOnChange={isRequireAcceptOnChange}
                        isSearchable={isSearchable}
                        defaultSelectedValues={defaultSelectedValues}
                        childKey={childKey}
                        dropdownDownIcon={dropdownDownIcon}
                        dropdownUpIcon={dropdownUpIcon}
                        isOptionDisabled={isOptionDisabled}
                        customSelectorStyles={customSelectorStyles}
                        inlineSelect={inlineSelect}
                        searchPlaceholder={searchPlaceholder}
                        customFilter={customFilter}
                        noOptionsMessage={noOptionsMessage}
                        isSelectDisabled={isSelectDisabled}
                        uniqueIdentifier={uniqueIdentifier}
                        iconRenderer={iconRenderer}
                        name={name}
                        expandLevel={expandLevel}
                        bottomBorder={bottomBorder}
                        customStyles={customStyles}
                        value={value}
                        />
                </label>
                <Error showError={showError} errorType={errorType} errorMessage={errorMessage}/>
            </div>
});

export default React.forwardRef((props, ref) => {
    const {form, onChange, name} = props;

    let defaultSelectedValues = form?.formState[name] ?? [];

    const wrapperOnChange = (selectedValue, event) => {
        if (form && form.handleFormChange) form.handleFormChange(selectedValue, event)
        if (onChange) onChange(selectedValue, event);
    }

    return <Formidable {...props} onChange={wrapperOnChange} defaultSelectedValues={defaultSelectedValues} ref={ref} Component={FormFieldTreeSelect}/>
});